import { render, staticRenderFns } from "./MatchesTab.vue?vue&type=template&id=f5f8ead0&scoped=true&"
import script from "./MatchesTab.vue?vue&type=script&lang=ts&"
export * from "./MatchesTab.vue?vue&type=script&lang=ts&"
import style0 from "./MatchesTab.vue?vue&type=style&index=0&id=f5f8ead0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f8ead0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VCol,VContainer,VIcon,VRow,VSkeletonLoader})
